import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ISpecialMarketDto, { ISpecialMarketIncompleteDto } from '@core/mappers/specials/dtos/ISpecialMarketDto';
import SpecialMarket, { SpecialMarketIncomplete } from '@core/models/specials/SpecialMarket';
import SpecialMarketEventMapper from '@core/mappers/specials/SpecialMarketEventMapper';
import SpecialMarketEvent from '@core/models/specials/SpecialMarketEvent';

const specialMarketEventMapper: SpecialMarketEventMapper = new SpecialMarketEventMapper();

type Input = ISpecialMarketDto | ISpecialMarketIncompleteDto;
type Output = SpecialMarket | SpecialMarketIncomplete;

export default class SpecialMarketMapper extends AbstractMapper<Input, Output> {

    createTargetObject(dto: ISpecialMarketDto) {
        const market = {
            id: dto.betGroupId,
        };

        if (this.isFullMarket(dto)) {
            const fieldDefinitions = JSON.parse(dto.fieldsDefinition).map((field: string) =>
                this.extractLocalizedString(field));
            const specialMarketEvents = dto.oddTypes
                    .map(oddType => specialMarketEventMapper.createTargetObject(oddType, {
                        fieldDefinitions,
                    }) as SpecialMarketEvent);

            const specialMarket = new SpecialMarket({
                ...market,
                fieldDefinitions,
                specialMarketEvents,
                name: this.extractLocalizedString(dto.betGroupName),
                footer: this.extractLocalizedString(dto.betGroupFooter),
                enteringCodes: JSON.parse(dto.enteringCodes),
            });

            return specialMarket;
        }

        return new SpecialMarketIncomplete({
            ...market,
            specialMarketEvents: (dto as ISpecialMarketIncompleteDto).oddTypes.map(oddType =>
                specialMarketEventMapper.createTargetObject(oddType))
        });
    }

    private isFullMarket(market: Input): market is ISpecialMarketDto {
        return market.hasOwnProperty('betGroupName');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/specials/SpecialMarketMapper.ts